(function() {
  var InviteTab,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  InviteTab = App.loadClass("grower::handlers/contacts/tabs/Invite_Tab_Handler");

  exports.Remove_Permission_Dialog = (function(superClass) {
    extend(Remove_Permission_Dialog, superClass);

    function Remove_Permission_Dialog() {
      return Remove_Permission_Dialog.__super__.constructor.apply(this, arguments);
    }

    Remove_Permission_Dialog.prototype.init = function() {
      this.classes = 'medium_dialog';
      this.layoutUrl = 'backend/grower/contacts/removepermissionform';
      this.saveUrl = 'backend/grower/contacts/removepermission-ajax';
      this.errorAction = function() {
        return this.dialog.find('.save-btn').addClass('hidden');
      };
      this.refreshNavHandler = false;
      this.successAction = function(data) {
        var i, ref, results, v;
        ref = App.current_page.activeSubHandlers;
        results = [];
        for (i in ref) {
          v = ref[i];
          if (v instanceof InviteTab) {
            results.push($(v.layoutSelector).find('.btn-search').click());
          } else {
            results.push(App.current_page.refreshSubHandlers());
          }
        }
        return results;
      };
      return this.createDialog();
    };

    Remove_Permission_Dialog.prototype.afterLoadLayout = function() {
      var ths;
      ths = this;
      this.openDialog();
      this.dialog.find('#affected-records').hide();
      this.dialog.find('.div-replace-permission').hide();
      this.dialog.find('.save-btn').hide();
      this.dialog.find('#frm_removepermission').validationEngine({
        promptPosition: "centerRight",
        ajaxFormValidationMethod: "POST"
      });
      this.submitAction = (function(_this) {
        return function() {
          var valid;
          valid = _this.dialog.find("#frm_removepermission").validationEngine('validate');
          if (valid) {
            return _this.save('Deleting Custom Permission... Assigning Replacement Permission...');
          }
        };
      })(this);
      this.dialog.find('#num-affected-btn').click(function(e) {
        var btn, magicDiv, parentDiv;
        e.preventDefault();
        btn = $(this);
        parentDiv = btn.parents('div');
        magicDiv = parentDiv.find('#affected-records');
        if (!btn.data('results')) {
          return $.post('backend/grower/contacts/get-affectedrecords-ajax', {
            'permission_id': ths.dialog.find('.sel-remove-permission').val()
          }, function(response) {
            var ref;
            if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
              return;
            }
            magicDiv.empty().append(response.view);
            btn.data('results', 'true');
            return magicDiv.toggle('fast');
          });
        } else {
          return magicDiv.toggle('fast');
        }
      });
      return this.dialog.find('.sel-remove-permission').change(function(e) {
        if (!$(this).val()) {
          ths.dialog.find('.div-replace-permission').hide('fast');
          ths.dialog.find('.save-btn').hide('fast');
          return;
        }
        return $.post('backend/grower/contacts/get-permissionremovalinfo-ajax', {
          'permission_id': $(this).val()
        }, function(json) {
          var numAffectedBtn, resultsDiv;
          resultsDiv = ths.dialog.find('.div-replace-permission');
          if (json.status.type === 'error') {
            return resultsDiv.replaceWith(json.status.msg);
          } else {
            resultsDiv.find('#affected-records').hide('fast').empty();
            numAffectedBtn = resultsDiv.find('#num-affected-btn');
            numAffectedBtn.removeData('results');
            if (json.data.num_affected === '0') {
              numAffectedBtn.addClass('disabled');
              numAffectedBtn.attr('disabled', 'disabled');
            } else {
              numAffectedBtn.removeClass('disabled');
              numAffectedBtn.removeAttr('disabled');
            }
            resultsDiv.show('fast');
            resultsDiv.find('.num-affected').empty().append(json.data.num_affected);
            if (json.data.num_affected !== '1') {
              resultsDiv.find('.word-contact').empty().append('contacts');
            } else {
              resultsDiv.find('.word-contact').empty().append('contact');
            }
            resultsDiv.find('.seldiv-replace-permission').empty().append(json.data.select);
            return ths.dialog.find('.save-btn').show('fast');
          }
        });
      });
    };

    return Remove_Permission_Dialog;

  })(DialogHandler);

}).call(this);
